<script>
export default {
  props: {
    data1: Array,
    columns: Array,
    columnsDisplayed: Object,
    filterKey: String,
    perPage: Number
  },
  data() {
    return {
      sortKey: '',
      sortOrders: this.columns.reduce((o, key) => ((o[key] = 1), o), {}),
      page: 1,
      pages: [],
      data: []
    }
  },

  computed: {
    displayedData() {
      return this.paginate(this.filteredData(this.data1));
    },
    displayedDataAll() {
      return this.filteredData(this.data1);
    }
  },

  watch: {
    displayedData() {
      this.setPages();
    }
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = 'https://cdn1.iconfinder.com/data/icons/unicons-line-vol-2/24/cloud-question-512.png'
    },
    sortBy(key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    setPages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.filteredData(this.data1).length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    filteredData() {
      const sortKey = this.sortKey
      const filterKey = this.filterKey && this.filterKey.toLowerCase()
      const order = this.sortOrders[sortKey] || 1
      let data = this.data1
      if (filterKey) {
        data = data.filter((row) => {
          return Object.keys(row).some((key) => {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = (page * perPage) - perPage;
      let to = (page * perPage);
      return data.slice(from, to);
    }
  }
}
</script>

<script setup>
import {ChevronDownIcon, ChevronUpIcon} from '@heroicons/vue/solid'
import {ChevronLeftIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon} from '@heroicons/vue/solid'
import {CheckCircleIcon, ChevronRightIcon, MailIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'


</script>

<template>

  <div v-if="displayedData.length">
    <table
        class="min-w-full divide-y divide-gray-300"
    >
      <thead class="bg-gray-50">
      <tr>
        <th
            v-for="(item, index) in columnsDisplayed"
            :key="index"
            :class="{ active: sortKey == index }"
            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            @click="sortBy(index)"
        >
          <a
              href="#"
              class="group inline-flex"
          >
            {{ capitalize(item) }}
            <span class="ml-2 flex-none rounded bg-gray-200 text-gray-900 group-hover:bg-gray-300">
              <ChevronDownIcon
                  v-if="sortOrders[index] > 0"
                  class="h-5 w-5"
                  aria-hidden="true"
              />
              <ChevronUpIcon
                  v-if="sortOrders[index] < 0"
                  class="h-5 w-5"
                  aria-hidden="true"
              />

            </span>
          </a>
          <span
              class="arrow"
              :class="sortOrders[index] > 0 ? 'asc' : 'dsc'"
          />
        </th>
      </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
      <tr
          v-for="entry in displayedData"
          :key="entry"
      >
        <td
            v-for="(item, index) in columnsDisplayed"
            :key="index"
            class="overflow-hidden  whitespace-wrap px-3 py-4 text-sm text-gray-500"
        >
          <span class="hidden bg-yellow-700 bg-green-700 bg-red-700  bg-fuchsia-700  bg-gray-700"></span>
          <div class="flex items-center" v-if="index === 'company_name'">
            <div class="h-7 w-7 flex-shrink-0">
              <img @error="onImageLoadFailure($event)" class="h-7 w-7 rounded-full" :src="entry['company_avatar']"
                   alt=""/>
            </div>
            <div class="ml-4">
              <div class="font-medium text-gray-900">{{ entry['company_name'] }}</div>
              <div class="text-gray-500">{{ entry['id'] }}</div>
            </div>
          </div>


          <span v-else-if="index === 'status_name'"
                :class="`inline-flex rounded-full bg-${entry['status_color']}-700  px-2 text-xs font-semibold leading-5 text-white`">
            {{ entry['status_name'] }}
          </span>

          <div v-else-if="index === 'amount'">
            <div class="text-gray-900">{{ entry['amount'] }}</div>
            <div class="text-gray-500">{{ entry['amount_tax'] }}</div>
          </div>
          <div v-else-if="index === 'button' ">
            <a :href="entry['file_url']" v-if="entry['status'] === 'ok' && entry['file_url'] !== null">
              <button type="button"
                      class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
              >
                Télécharger
              </button>
            </a>

            <button type="button" v-if="entry['status'] === 'pending'"
                    class="ml-3 relative inline-flex items-center font-bold px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    disabled="">
              <svg  class="animate-spin h-5 w-5 text-indigo-500"
                   xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </button>
          </div>

          <div v-else>
            {{ entry[index] }}
          </div>

        </td>
      </tr>
      </tbody>
    </table>

    <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
      <div class="flex-1 flex justify-between sm:hidden">
        <a href="#" v-if="page != 1" @click="page--"
           class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          Previous </a>
        <a href="#" @click="page++" v-if="page < pages.length"
           class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          Next </a>
      </div>
      <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p class="text-sm text-gray-700">
            Showing
            {{ ' ' }}
            <span class="font-medium">{{ page }}</span>
            {{ ' ' }}
            to
            {{ ' ' }}
            <span class="font-medium">{{ pages.length }}</span>
            {{ ' ' }}
            of
            {{ ' ' }}
            <span class="font-medium">{{ displayedDataAll.length }}</span>
            {{ ' ' }}
            results
          </p>
        </div>
        <div>
          <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a href="#" @click="page = 1"
               class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">First</span>
              <ChevronDoubleLeftIcon class="h-5 w-5" aria-hidden="true"/>
            </a>
            <a href="#" v-if="page != 1" @click="page--"
               class="relative inline-flex items-center px-2 py-2  border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Previous</span>
              <ChevronLeftIcon class="h-5 w-5" aria-hidden="true"/>
            </a>
            <!-- Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" -->
            <a href="#" aria-current="page" v-bind:key="pageNumber" type="button"
               v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber"
               :class="[ pageNumber === page ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium': 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium']">
              {{ pageNumber }}</a>

            <a href="#" @click="page++" v-if="page < pages.length"
               class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Next</span>
              <ChevronRightIcon class="h-5 w-5" aria-hidden="true"/>
            </a>

            <a href="#" @click="page = pages.length"
               class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Last</span>
              <ChevronDoubleRightIcon class="h-5 w-5" aria-hidden="true"/>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div
      v-else-if="displayedData.length === 0"
      class="bg-white"
  >
    <div class="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
        <span class="block">Il n'y a aucune facture ici !</span>
        <span class="block"></span>
      </h2>

    </div>
  </div>

</template>
